export default __webpack_public_path__ + "dist/images/waveplayer/png/up_arrow.png";